import { WooCommerceDeliveryAddress } from '../../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';

export class SetDeliveryAddresses {
  static readonly type = '[Delivery] Set Delivery Addresses';
  constructor(public payload: WooCommerceDeliveryAddress[]) {}
}

export class AddDeliveryAddress {
  static readonly type = '[Delivery] Add Delivery Address';
  constructor(public payload: WooCommerceDeliveryAddress) {}
}

export class RemoveDeliveryAddress {
  static readonly type = '[Delivery] Remove Delivery Address';
  constructor(public payload: WooCommerceDeliveryAddress) {}
}
